import ToggleSwitch from "legacy/ToggleSwitch"
import PropTypes from "prop-types"
import React, { useState } from "react"

const FormToggle = ({ value = false, fieldName }) => {
  // The local state tracks changes made by the user
  const [toggleValue, setToggleValue] = useState(value)

  // Convert boolean value to position
  const getTogglePosition = () => (toggleValue === false ? "left" : "right")

  // Handle toggle change event
  const handleToggleChange = (togglePosition) => {
    const positionToValue = {
      left: false,
      right: true,
    }
    setToggleValue(positionToValue[togglePosition])
  }

  // Use the prop for rendering, and the local state for the input value
  return (
    <div>
      <ToggleSwitch
        tellParent={handleToggleChange}
        startPosition={getTogglePosition()}
      />
      <input
        type="hidden"
        name={fieldName}
        // Ensure value is always a string to avoid controlled/uncontrolled warning
        value={toggleValue.toString()}
      />
    </div>
  )
}

FormToggle.propTypes = {
  value: PropTypes.bool,
  fieldName: PropTypes.string.isRequired,
}

export default FormToggle
